<template>
    
    <div v-if="data" class="w-full border-b mb-2 flex flex-col" :class="{'h-32': !open, 'h-96': open}" style="transition: all .3s;">

        <div class="h-32 w-full flex flex-row" @click="openDetail()" >
        
            <div class="h-full w-2/5 p-2">
            
                <div class="h-full w-full rounded-lg shadow-md bg-white" :style="'background-image: url('+ data.image +'); background-repeat: no-repeat; background-size: cover; background-position: center;'"></div>

            </div>

            <div class="h-full w-3/5 flex flex-col justify-start items-start px-4 py-1">
            
                <span class="text-black text-md font-semibold">{{data.name}}</span>
                <span class="text-gray-700 text-sm -mt-1">{{data.price | reduceBigNumbers() }}€</span>
                <div class="h-auto w-full flex flex-row justify-start items-center mt-auto">
                    <span class="text-green-500">{{data.sales}}</span>
                    <i class="mdi mdi-package-variant-closed text-green-500 mr-auto"></i>
                    <span class="text-blue-500 text-lg font-semibold">{{data.amount | reduceBigNumbers() }}€</span>
                </div>
            
            </div>

        </div>

        <div v-if="open" class="flex-1 overflow-hidden flex flex-col">

            <Find :model="'products'" :primary-key="data.id" :immediate="false" v-slot="{data:detail, loading}" ref="product">
            
                <div v-if="!loading && detail" class="h-full flex flex-col">

                    <div class="h-12 border flex flex-row justify-between items-center px-4 overflow-x-auto">

                        <div v-for="(el,index) in detail.data.variants" :key="index" class="h-full w-auto flex flex-col justify-center items-center mr-2">

                            <span class="text-xs cursor-pointer font-bold">{{el.name}}</span>
                            <span class="text-xs cursor-pointer">{{el.stock}}</span>

                        </div>

                    </div>

                    <div class="h-auto border flex flex-row justify-between items-center">

                        <div class="h-full w-1/3 flex flex-row justify-center items-center cursor-pointer" :class="{'bg-blue-200 text-blue-700 font-bold': typeSelected == 'sales'}" @click="typeSelected = 'sales'">
                            <span class="text-xs">Ventas</span>
                        </div>

                        <div class="h-full w-1/3 flex flex-row justify-center items-center cursor-pointer" :class="{'bg-blue-200 text-blue-700 font-bold': typeSelected == 'stock'}" @click="typeSelected = 'stock'">
                            <span class="text-xs">Stock</span>
                        </div>

                        <div class="h-full w-1/3 flex flex-row justify-center items-center cursor-pointer" :class="{'bg-blue-200 text-blue-700 font-bold': typeSelected == 'price'}" @click="typeSelected = 'price'">
                            <span class="text-xs">Precio</span>
                        </div>

                    </div>

                    <div class="flex-1 py-1">

                        <chartarea v-if="typeSelected == 'sales'" :data="detail.data.graph.sales" chartId="graph"></chartarea>
                        <chartarea v-if="typeSelected == 'stock'" :data="detail.data.graph.stock" chartId="graph"></chartarea>
                        <chartarea v-if="typeSelected == 'price'" :data="detail.data.graph.price" chartId="graph"></chartarea>

                    </div>

                </div>

            </Find>

        </div>

    </div>

</template>

<script>
import { Find } from '@/api/components';
import chartarea from './chartareastock.vue';

export default {
    props:['data'],
    components:{
        Find,
        chartarea
    },
    data(){
        return {
            open: false,
            typeSelected: 'sales',
        }
    },
    methods:{
        async openDetail(){
            this.open = !this.open;
            await this.$nextTick();
            
            if(this.open){
                console.log('refs: ', this.$refs.product)
                this.$refs.product.request();
            }
        }
    },
    computed:{
        param(){
            return this.data.id
        },
        datagraph(){

            

        }
    }
}
</script>